import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Users from './components/Users';
import Plans from './components/Plans';
import Addons from './components/Addons';
import Avatars from './components/Avatars';
import DueForDeletion from './components/DueForDeletion';
// import Reports from './components/Reports';
import PrivateRoute from './components/PrivateRoute';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          }
        />
        <Route
          path="/plans"
          element={
            <PrivateRoute>
              <Plans />
            </PrivateRoute>
          }
        />
        <Route
          path="/addons"
          element={
            <PrivateRoute>
              <Addons />
            </PrivateRoute>
          }
        />
        <Route
          path="/avatars"
          element={
            <PrivateRoute>
              <Avatars />
            </PrivateRoute>
          }
        />
        <Route
          path="/due-for-deletion"
          element={
            <PrivateRoute>
              <DueForDeletion />
            </PrivateRoute>
          }
        />
{/*
        <Route
          path="/reports"
          element={
            <PrivateRoute>
              <Reports />
            </PrivateRoute>
          }
        />
*/}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Router>
  );
}

export default App;

